export default __webpack_public_path__ + "static/media/TheMixC5-6_SemiBold.7557b729.woff2";